import React, { useEffect, useRef, useState } from 'react';
import { Toolbar } from 'primereact/toolbar';
import ToshibaIcon from './../assets/icons/logo-white.png';
import NameDisplay from './NameDisplay';
import storage from './../utils/storage';
import { useDispatch, useSelector } from 'react-redux';
import { Toast } from 'primereact/toast';
import { clearToast } from './../utils/toastReducer';

const SiteHeader = ({ centerContent }) => {

    const dispatch = useDispatch();
    const toast = useRef(null); 

    // Get toastMessage from Redux store
    const toastMessage = useSelector((state) => state?.toast?.toastMessage);

    // Show toast whenever there's a new message
    useEffect(() => {
        if (toastMessage && toast?.current) {
            toast.current.show({
                severity: toastMessage?.severity,
                summary: toastMessage?.summary,
                detail: toastMessage?.detail,
                life: 3000, // Auto hide after 3 seconds
            });

            // Clear the toast after showing it
            dispatch(clearToast());
        }
    }, [toastMessage, dispatch]);
    
    const [settings, setSettings] = useState({
        isThemeVisible: false,
        isNotificationVisible: false,
    });

    const startContent = (
        <>
            <img src={ToshibaIcon} alt="logo" />
        </>
    );

    const onSettingsClick = () => {
        setSettings({
            isThemeVisible: !settings.isThemeVisible,
            isNotificationVisible: false,
        });
    };

    const handleLogout = () => {
        storage.clear();
        window.location.href = '/';
    };

    const endContent = (
        <>
            <Toast ref={toast} />
            <div>
                <NameDisplay toggleThemeVisibility={onSettingsClick} />
                <div
                    className={
                        settings.isThemeVisible
                            ? 'slide display-block'
                            : 'slide display-none'
                    }
                >
                    <a
                        className="dropdown-item"
                        href="/"
                        onClick={(event) => {
                            event.preventDefault();
                            handleLogout();
                        }}
                    >
                        Log Out
                    </a>
                </div>
            </div>
        </>
    );

    return (
        <div className="card fixed-nav">
            <Toolbar
                start={startContent}
                center={centerContent}
                end={endContent}
                className="taskbar shadow-2 border-noround border-none"
                style={{ backgroundColor: '#2E3643' }}
            />
        </div>
    );
};

export default SiteHeader;
